import { Grid, Typography } from '@mui/material';
import { MemberQuestions } from "./MemberQuestions";
import { SessionTags } from './SessionTags';
import { useGetSessionQuery } from '../services/api';

export function SessionDialogDetails({
  guid
}: {
  guid?: string;
}) {
  const { data: session } = useGetSessionQuery(guid);
  return (
    <Grid
      container
      item
      md={8}
      sx={{
        marginTop: 1
      }}
      xs={12}
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          fontWeight={500}
        >Description</Typography>
        <Typography
          gutterBottom
        >{session?.description}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Typography
          fontWeight={500}
        >Tags</Typography>
        <SessionTags
          guid={guid} />
      </Grid>
      {session?.unavailable && <>
        <Grid
          item
          xs={12}
        >
          <Typography
            fontStyle='italic'
            fontWeight={500}
          >This session is unavailable at this time.</Typography>
        </Grid>
      </>}
      <Grid
        item
        sx={{
          marginTop: 1
        }}
        xs={12}
      >
        <Typography
          fontWeight={500}
        >Have a question?</Typography>
        <br />
        <Typography
          gutterBottom
        >Send your questions to the session organizer.</Typography>
        <MemberQuestions
          guid={guid} />
      </Grid>
    </Grid>
  );
}
